(function (M) {
  if (!M) return;
  var d = document;
  if (!d.querySelector('.nm')) return;
  M.tag('.nm-hero .nm-tag', 'up', { d: 0.05 });
  var h1 = d.querySelector('.nm-hero h1');
  if (h1) {
    var words = [];
    [].slice.call(h1.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = d.createDocumentFragment();
        n.data.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(p)); return; }
          var s = d.createElement('span');
          s.className = 'mo-w';
          s.textContent = p;
          frag.appendChild(s);
          words.push(s);
        });
        h1.replaceChild(frag, n);
      } else if (n.nodeType === 1 && n.tagName !== 'BR') {
        n.classList.add('mo-w');
        words.push(n);
      }
    });
    M.tag(words, 'up', { d: 0.2, step: 0.13 });
  }
  M.tag('.nm-hero .sub, .nm-hero p, .nm-hero .ctas', 'up', { d: 0.75, step: 0.12 });
  var ph = d.querySelector('.nm-hero .ph');
  if (ph) {
    M.tag(ph, 'zoom', { d: 0.2 });
    var pimg = ph.querySelector('img');
    if (pimg) pimg.classList.add('mo-float');
  }
  M.tag('.nm-cat .hd > *', 'up', { step: 0.1 });
  M.tag('.nm-card', 'rise', { d: 0.1, step: 0.15 });
  M.all('.nm-spec div').forEach(function (row) {
    var label = (row.querySelector('span') || {}).textContent || '';
    var b = row.querySelector('b');
    if (!b || !/총 NMN|캡슐 수|Total NMN|^Capsules$|NMN総量|カプセル数|NMN total|^Cápsulas$/.test(label.trim())) return;
    var n = b.textContent.match(/\d[\d,]*/);
    if (n) M.count(b, n[0]);
  });
  M.tag('.nm-sci .nm-kick, .nm-sci h2, .nm-sci .lead', 'up', { step: 0.1 });
  M.tag('.nm-feat > div', 'left', { d: 0.1, step: 0.12 });
  var orb = d.querySelector('.nm-orb');
  if (orb) {
    M.tag(orb, 'zoom', { d: 0.15 });
    orb.setAttribute('data-mo-play', '');
    orb.classList.add('mo-orbit');
    orb.insertAdjacentHTML('afterbegin',
      '<span class="mo-glow mo-deco" aria-hidden="true"></span>' +
      '<span class="mo-dash mo-deco" aria-hidden="true"></span>' +
      '<span class="mo-sat mo-deco" aria-hidden="true"></span>' +
      '<span class="mo-sat s2 mo-deco" aria-hidden="true"></span>');
    var dots = M.all('.d', orb);
    var place = function () {
      var r = orb.clientWidth / 2;
      dots.forEach(function (dot) {
        dot.style.transformOrigin = (r - dot.offsetLeft) + 'px ' + (r - dot.offsetTop) + 'px';
      });
    };
    place();
    window.addEventListener('resize', place);
  }
})(window.FJKMotion);
